/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'orders': {
    width: 18,
    height: 22,
    viewBox: '0 0 18 22',
    data: '<path pid="0" d="M12.653 18.683l.05-1.269-10.92-1.001-.051.906c-.029.515.442 1.031 1.066 1.118l10.116 1.474a2.573 2.573 0 0 1-.261-1.228zm-10.009.812C1.49 19.335.593 18.352.654 17.26l.062-1.117c.028-.502.48-.855.984-.811l2.272.208.653-12.96a1 1 0 0 1 .85-.917L16.603.01c.568-.088 1 .371.98.926l-.637 18.187c-.047 1.327-1.066 2.307-2.295 2.12l-12.007-1.75zm10.293-3.133l-7.89-.723.652-12.93 10.799-1.602-.631 17.98c-.026.723-.505 1.184-1.053 1.1-.608-.092-1.11-.749-1.083-1.463l.054-1.358c.019-.501-.343-.955-.848-1.004zM14.79 5.486l.068-1.408-7.7.708-.048 1.292 7.68-.592zm-.166 3.47l.068-1.408L7.005 8l-.048 1.292 7.667-.337zM14.4 12.45l.069-1.408-7.668.043-.048 1.292 7.647.073z" _fill="#848484" fill-rule="evenodd"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/orders.js